import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Button } from '@app/core';
import { Trans, useTranslation } from 'react-i18next';
import {
  FLASH_OFFER_ANNON_URL,
  FLASH_OFFER_CALENDAR_LINK,
  useIsSpecialOfferBannerActive,
} from './isSpecialOfferActive';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.marginBase * 3,
    width: '100%',

    backgroundColor: theme.colors.accentMuted,
    borderRadius: theme.borderRadius.large,
    padding: theme.marginBase * 3,
    marginTop: theme.marginBase * 4,
  },
  text: {
    ...theme.fonts.h4,
    flex: 1,
    color: theme.colors.inkPrimary,
    '& strong': {
      color: theme.colors.inkPrimary,
    },
  },
  buttons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.marginBase,
  },
}));

export const SpecialOfferQuoteBlock = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const isSpecialOfferActive = useIsSpecialOfferBannerActive();
  if (!isSpecialOfferActive) {
    return null;
  }

  return (
    <div className={classes.container}>
      <p className={classes.text}>
        <Trans i18nKey="billing.specialOffer.bigBlock.quote" />
      </p>
      <Button
        color="accent"
        to={FLASH_OFFER_ANNON_URL}
        small
        variant="muted"
        target={FLASH_OFFER_ANNON_URL.startsWith('http') ? '_blank' : undefined}
      >
        {t('billing.specialOffer.bigBlock.view')}
      </Button>
      <Button
        color="accent"
        href={FLASH_OFFER_CALENDAR_LINK}
        target="_blank"
        small
      >
        {t('billing.specialOffer.bigBlock.call')}
      </Button>
    </div>
  );
};
